import React from 'react';
import ReleasesActions, { thunks as ReleasesThunks } from 'reducers/Releases';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ReleaseListHeaderCell from './ReleaseListHeaderCell';

const mapStateToProps = ({ releases }) => ({
	artistColumnWidth: releases.artistColumnWidth,
	titleColumnWidth: releases.titleColumnWidth
});
@connect(
	mapStateToProps,
	null
)
class ReleaseListHeader extends React.PureComponent {
	static propTypes = {
		artistColumnWidth: PropTypes.number,
		titleColumnWidth: PropTypes.number,
		dispatch: PropTypes.func,
		t: PropTypes.func.isRequired
	}

	componentDidMount() {
		this.isMovingBarrier = false;
		this.movingBarrierIndex = -1;
		this.lastPosition = 0;
	}

	handleMouseMove = event => {
		const { isMovingBarrier, movingBarrierIndex, lastPosition } = this;
		const { artistColumnWidth, titleColumnWidth, dispatch } = this.props;
		if (isMovingBarrier) {
			const x = event.clientX;
			if (movingBarrierIndex === 0) {
				this.lastPosition = x;
				dispatch(
					ReleasesActions.updateArtistColumnWidth(
						artistColumnWidth + x - lastPosition
					)
				);
			} else if (movingBarrierIndex === 1) {
				this.lastPosition = x;
				dispatch(
					ReleasesActions.updateTitleColumnWidth(
						titleColumnWidth + x - lastPosition
					)
				);
			}
		}
	}

	handleMouseUp = () => {
		setTimeout(() => {
			this.isMovingBarrier = false;
		}, 50);
		// This delay is added in order to prevent the onclick on the field to be mistriggered in dragging.
	}

	handleSortBy = attribute => {
		const { dispatch } = this.props;
		dispatch(ReleasesThunks.sortBy(attribute));
	}

	handleMouseDownSeparator = (event, index) => {
		this.isMovingBarrier = true;
		this.lastPosition = event.clientX;
		this.movingBarrierIndex = index;
	}

	handleClickOnField = field => {
		const { isMovingBarrier } = this;
		if (!isMovingBarrier) {
			this.handleSortBy(field);
		}
	}

	render() {
		const { artistColumnWidth, titleColumnWidth, t } = this.props;
		return (
			<div className="relative w-full my-4">
				<div
					className="flex flex-row items-center justify-start w-full"
					onMouseMove={this.handleMouseMove}
					onMouseUp={this.handleMouseUp}
					onMouseLeave={this.handleMouseUp}>
					<div className="relative w-12 h-12 mx-6 flex-none" />
					<ReleaseListHeaderCell
						flexGrow
						width={artistColumnWidth}
						name={t('release-list.artist')}
						onClickOnField={() => {
							this.handleClickOnField('artist');
						}}
						onMouseDownSeparator={event => {
							event.stopPropagation();
							this.handleMouseDownSeparator(event, 0);
						}} />
					<ReleaseListHeaderCell
						flexGrow
						width={titleColumnWidth}
						name={t('release-list.title')}
						onClickOnField={() => {
							this.handleClickOnField('title');
						}}
						onMouseDownSeparator={event => {
							event.stopPropagation();
							this.handleMouseDownSeparator(event, 1);
						}} />
					<ReleaseListHeaderCell
						flexGrow
						width={60}
						name={t('release-list.duration')}
						onClickOnField={() => {
							this.handleClickOnField('time');
						}} />
					<ReleaseListHeaderCell
						flexGrow
						width={30}
						name={t('release-list.tracks')} />
					<ReleaseListHeaderCell
						flexGrow
						width={100}
						name={t('release-list.available-date')}
						additionalClassName="xl:flex hidden"
						onClickOnField={() => {
							this.handleClickOnField('-date');
						}} />
					<ReleaseListHeaderCell
						flexGrow
						width={100}
						name={t('release-list.label')}
						additionalClassName="xl:flex hidden" />
					<ReleaseListHeaderCell
						flexGrow
						width={100}
						name={t('release-list.formats')}
						additionalClassName="xl:flex hidden" />
					<div className="w-12" />
					<div className="w-12" />
				</div>
			</div>
		);
	}
}
export default withTranslation()(ReleaseListHeader);
